"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Set the FindFoldersRequestStatus in the inbox rules options store
 * @param requestStatus the get inbox rules request status to set
 */
exports.default = legacy_1.action('setGetInboxRuleRequestStatus')(function setGetInboxRuleRequestStatus(requestStatus) {
    store_1.default.findFoldersRequestStatus = requestStatus;
});
//# sourceMappingURL=setFindFoldersRequestStatus.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/setFindFoldersRequestStatus.js
// module id = 5225
// module chunks = 2